import React from 'react';
import { Link } from 'react-router-dom';
import './DemoPage.css';
import AnalyticsHeader from './AnalyticsHeader';
import DemoWorkspace from './DemoWorkspace';

const DemoPage: React.FC = () => {
  return (
    <div className="demo-page-root">
      <div className="demo-sidebar">
        <button className="tool-button" title="Главная">
          <i className="fas fa-home"></i>
        </button>
        <button className="tool-button" title="Статистика">
          <i className="fas fa-chart-line"></i>
        </button>
        <button className="tool-button" title="Отчеты">
          <i className="fas fa-file-alt"></i>
        </button>
        <button className="tool-button" title="Настройки фильтров">
          <i className="fas fa-filter"></i>
        </button>
        <button className="tool-button" title="Экспорт">
          <i className="fas fa-download"></i>
        </button>
        <button className="tool-button" title="Сравнение">
          <i className="fas fa-balance-scale"></i>
        </button>
        <button className="tool-button" title="Избранное">
          <i className="fas fa-star"></i>
        </button>
        <button className="tool-button" title="Настройки">
          <i className="fas fa-cog"></i>
        </button>
        <button className="tool-button" title="Помощь">
          <i className="fas fa-question-circle"></i>
        </button>
      </div>
      <header className="demo-header">
        <Link to="/" className="demo-logo-container">
          <div className="logo-placeholder">
            <div className="logo-chart">
              <div className="logo-chart-bar"></div>
            </div>
          </div>
        </Link>
        <div className="demo-user-greeting">Добро пожаловать, Гость</div>
      </header>
      <div className="demo-main-content">
        <AnalyticsHeader />
        <DemoWorkspace />
      </div>
    </div>
  );
};

export default DemoPage; 